export function formatPrice(price: number): string {
    if (price >= 1_000_000) {
      return '100万円以上';
    }
    // カンマ区切り
    return price.toLocaleString();
}